export default theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  textfield: {
    position: "relative",
    width: "100%"
  },
  searchButton: {
    display: "inline-block",
    float: "right"
  },
  fromDatePicker: {
    flex: 1,
    marginRight: "15px"
  },
  toDatePicker: {
    flex: 1
  },
  fieldError: {
    color: theme.palette.danger.main,
    position: "absolute",
    left: 0,
    top: "60px"
  },
  container: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  searchContainer: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    marginBottom: "50px",
    maxHeight: "570px",
    display: "flex",
    flexDirection: "column"
  },
  dataContainer: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    flexGrow: "1",
    maxWidth: "100%"
  },
  checkBoxField: {
    marginRight: "2rem"
  },
  inputWrapper: {
    flex: 1,
    position: "relative",
    marginRight: "15px"
  },
  filterItems: {
    maxWidth: "1600px",
    display: "flex",
    flexWrap: "wrap",
    marginTop: "2rem"
  }
});
